import { useState, type ChangeEventHandler } from "react";

interface PasswordFieldProps {
  id: string;
  label: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  autoComplete: string;
  placeholder: string;
  minLength?: number;
  required?: boolean;
}

function EyeIcon() {
  return (
    <svg className="password-toggle-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M2.1 12s3.6-6.3 9.9-6.3S21.9 12 21.9 12s-3.6 6.3-9.9 6.3S2.1 12 2.1 12Z" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="12" cy="12" r="2.8" fill="none" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

function EyeOffIcon() {
  return (
    <svg className="password-toggle-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M3.8 3.8 20.2 20.2" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M9.6 5.9A10 10 0 0 1 12 5.7c6.3 0 9.9 6.3 9.9 6.3a16 16 0 0 1-3.1 3.7" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M14.1 14.1a2.8 2.8 0 0 1-4-4" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M6.7 7.6A16.5 16.5 0 0 0 2.1 12s3.6 6.3 9.9 6.3c1.4 0 2.7-.3 3.8-.8" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function PasswordField({
  id,
  label,
  value,
  onChange,
  autoComplete,
  placeholder,
  minLength,
  required = true,
}: PasswordFieldProps) {
  const [visible, setVisible] = useState(false);
  const labelId = `${id}-label`;

  return (
    <div className="form-group">
      <label id={labelId} htmlFor={id} className="form-label">{label}</label>
      <div className="password-input-wrap">
        <input
          id={id}
          type={visible ? "text" : "password"}
          autoComplete={autoComplete}
          required={required}
          minLength={minLength}
          value={value}
          onChange={onChange}
          className="form-input password-input"
          placeholder={placeholder}
          aria-labelledby={labelId}
        />
        <button
          type="button"
          className="password-toggle"
          aria-label={visible ? "Hide password" : "Show password"}
          aria-pressed={visible}
          onClick={() => setVisible((v) => !v)}
        >
          {visible ? <EyeOffIcon /> : <EyeIcon />}
        </button>
      </div>
    </div>
  );
}
